/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
// import { BreakPoint } from '../../../asset/styles';
import Close from '../../../../component/button/Close';

const StyledClose = styled.div`
  margin-left: 16px;
`;

/**
 * {@link Inquiry} 閉じるボタン
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} 閉じるボタン
 * @constructor
 */
const HeaderClose = ({ 'data-testid': testId = 'HeaderClose', ...props }) => (
  <StyledClose className={'CloseButton'} data-testid={testId}>
    <Close {...props} color={'red'} />
  </StyledClose>
);

export default HeaderClose;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/header/HeaderClose.js